import { IonApp, IonButton, IonContent, IonInput, IonPopover, IonSlide, IonSlides } from "@ionic/react";
import React, { Component } from "react";
import Footer from "../../components/Footer";
import GoogleSignin from "../../components/GoogleSignin";
import OrButton from "../../components/OrButton";
import Toolbar from "../../components/Toolbar";
import Firebase from "../../firebase";
import { REGEX } from "../../regex";
import { URLS } from "../../urls";
import "./style.css";

class Login extends Component {
    state = {
        fb: Firebase.getInstance(),
        popoverOpen: false,
        popoverMessage: "",
        slides: React.createRef<HTMLIonSlidesElement>() as any,
    };

    componentDidMount() {
        document.dispatchEvent(new Event("pageMount"));
    }

    render() {
        return (
            <IonApp>
                <Toolbar />
                <IonContent>
                    <IonPopover
                        isOpen={this.state.popoverOpen}
                        cssClass="register__popover"
                        onDidDismiss={(e) => {
                            this.setState({ popoverOpen: false });
                        }}
                    >
                        {this.state.popoverMessage}
                    </IonPopover>
                    <br />
                    <IonSlides ref={this.state.slides} options={{ allowTouchMove: false }}>
                        <IonSlide>
                            <form
                                onSubmit={async (e: any) => {
                                    e.preventDefault();
                                    const email = (document.getElementById("loginEmail") as any).value;
                                    const pass = (document.getElementById("loginPass") as any).value;
                                    const res = await this.state.fb.signin(email, pass);
                                    if (res.message) {
                                        this.setState({
                                            popoverOpen: true,
                                            popoverMessage: res.message,
                                        });
                                        return;
                                    }
                                    const userData = await this.state.fb.readData("users/public/$uid");
                                    if (!userData) {
                                        const user = await this.state.fb.getUser();
                                        await this.state.fb.setUserData(user.email.split("@")[0]);
                                        await new Promise((resolve) => setTimeout(resolve, 500));
                                    }
                                    document.addEventListener(
                                        "authYes",
                                        () => {
                                            window.location.pathname = "/";
                                        },
                                        { once: true }
                                    );
                                }}
                            >
                                <GoogleSignin />
                                <br />
                                <OrButton />
                                <IonInput
                                    placeholder='דוא"ל'
                                    type="email"
                                    id="loginEmail"
                                    pattern={REGEX.email}
                                    required
                                    style={{ direction: "ltr" }}
                                ></IonInput>
                                <div
                                    className="login__forgot"
                                    onClick={() => {
                                        this.state.slides.current.slideNext();
                                    }}
                                >
                                    שכחתי סיסמה
                                </div>
                                <br />
                                <IonInput
                                    placeholder="סיסמה"
                                    type="password"
                                    id="loginPass"
                                    clearOnEdit={false}
                                    minlength={6}
                                    pattern={REGEX.password}
                                    required
                                    style={{ direction: "ltr" }}
                                ></IonInput>
                                <br />
                                <IonButton type="submit">התחברות</IonButton>
                            </form>
                        </IonSlide>
                        <IonSlide>
                            <form
                                onSubmit={async (e: any) => {
                                    e.preventDefault();
                                    const email = (document.getElementById("loginEmail_forgot") as any).value;
                                    await this.state.fb.resetEmail(email);
                                    alert("מייל שחזור נשלח בהצלחה!");
                                    window.location.pathname = URLS.LOGIN.url;
                                }}
                            >
                                <IonInput
                                    placeholder='דוא"ל'
                                    type="email"
                                    id="loginEmail_forgot"
                                    pattern={REGEX.email}
                                    required
                                    style={{ direction: "ltr" }}
                                ></IonInput>
                                <div
                                    className="login__forgot"
                                    onClick={() => {
                                        this.state.slides.current.slidePrev();
                                    }}
                                >
                                    חזרה למסך ההתחברות
                                </div>
                                <br />
                                <IonButton type="submit">שחזור סיסמה</IonButton>
                            </form>
                        </IonSlide>
                    </IonSlides>
                    <br />
                    <Footer />
                </IonContent>
            </IonApp>
        );
    }
}

export default Login;
